export default "__VITE_ASSET__CXY5YQW$__"